import "./Styles.css";

import React, { Component } from "react";
import { connect } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Offers from "../offers";
import Applications from "../applications";
import Settings from "../settings";
import NoMatch from "./NoMatch";
import AppLoading from "./AppLoading";
import { SignIn, SignUp, ResetPassword, SetPassword } from "../auth";
import { userIsNotAuthenticated, userIsAuthenticated } from "../auth/utils";

import getUserConfirmation from "./getUserConfirmation";
import { refreshToken, getCurrentUser } from "../auth/actions";

import routes from "../routes";

class App extends Component {
  componentDidMount() {
    const { token } = this.props;
    if (token) {
      this.refreshToken(token);
    }
  }
  componentWillReceiveProps(nextProps) {
    const { token } = this.props;
    if (token === null && nextProps.token) {
      this.refreshToken(nextProps.token);
    }
  }

  refreshToken = async token => {
    const { refreshToken, getCurrentUser } = this.props;
    await refreshToken(token);
    if (token) {
      const uid = JSON.parse(atob(token.token.split(".")[1])).uid;
      getCurrentUser(uid);
    }
  };

  render() {
    return (
      <Router getUserConfirmation={getUserConfirmation}>
        <div>
          <AppLoading />
          <ToastContainer
            position="bottom-right"
            type="success"
            autoClose={5000}
            hideProgressBar
            newestOnTop={true}
            closeOnClick
            pauseOnHover
          />

          <Switch>
            <Route
              exact
              path={"/"}
              render={() => <Redirect to={routes.offers} />}
            />
            <Route
              exact
              path={routes.offers}
              component={userIsAuthenticated(Offers.List)}
            />
            <Route
              exact
              path={routes.offersAdd}
              component={userIsAuthenticated(Offers.Add)}
            />
            <Route
              exact
              path={routes.offersEdit}
              component={userIsAuthenticated(Offers.Edit)}
            />

            <Route
              exact
              path={routes.applications}
              component={userIsAuthenticated(Applications.List)}
            />
            <Route
              exact
              path={routes.applicationsSingle}
              component={userIsAuthenticated(Applications.Single)}
            />

            <Route
              exact
              path={routes.settings}
              component={userIsAuthenticated(Settings.Form)}
            />

            <Route
              path={routes.signIn}
              component={userIsNotAuthenticated(SignIn)}
            />
            <Route
              path={routes.signUp}
              component={userIsNotAuthenticated(SignUp)}
            />
            <Route
              path={routes.resetPassword}
              component={userIsNotAuthenticated(ResetPassword)}
            />
            <Route path={routes.setPassword} component={SetPassword} />
            <Route component={NoMatch} />
          </Switch>
        </div>
      </Router>
    );
  }
}

App = connect(
  state => ({
    token: state.auth.token
  }),
  { refreshToken, getCurrentUser }
)(App);
export default App;



// WEBPACK FOOTER //
// ./src/app/App.js